import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

import ExperienceInsightsModel from './experience-insights-model';

function fetchExperienceTotals({ id }) {
  return ajaxService
    .post('/api/insight/object/campaignObjectTotals', {
      id,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(ExperienceInsightsModel.create);
}

export default {
  fetchExperienceTotals,
};
